// extracted by mini-css-extract-plugin
module.exports = {"StudentTrackingPage":"StudentTrackingPage_StudentTrackingPage__2ohfZ"};